export default {"src":"/_next/static/media/66.686892ed.svg","height":30,"width":96,"blurWidth":0,"blurHeight":0};